import animation from '@helpers/animation';
import brand from '@helpers/brand';
import fonts from '@helpers/fonts';
import { customScrollbar } from '@helpers/global';
import { Device, from } from '@helpers/media';
import styled, { css } from 'styled-components';

const Wrapper = styled.div<{ showYBorders: boolean }>`
  position: relative;
  cursor: pointer;
  padding: 16px 0px;
  display: flex;
  flex-direction: column;
  user-select: none;

  @media ${from(Device.Mobile)} {
    padding: 16px 24px;
  }

  @media ${from(Device.Tablet)} {
    flex-direction: row;
    align-items: center;
    border-left: 1px solid ${brand.grey[80]};
    border-right: 1px solid ${brand.grey[80]};
    height: 46px;

    ${({ showYBorders }) =>
      showYBorders
        ? css`
            border-top: 1px solid ${brand.grey[80]};
            border-bottom: 1px solid ${brand.grey[80]};
          `
        : null}
  }

  @media ${from(Device.Tablet)} {
    padding: 0px 24px;
  }
`;

const Title = styled.div`
  ${fonts.helvetica['93-black-extended']};
  font-size: 16px;
  color: ${brand.black};
  text-transform: uppercase;
  display: block;
  flex-shrink: 0;
`;

const List = styled.ul`
  position: absolute;
  z-index: 2;
  top: 100%;
  left: -1px;
  width: calc(100% + 2px);
  max-height: calc(48px * 8);
  overflow: auto;
  padding: 0;
  margin: 0;
  border: 1px solid ${brand.grey[80]};
  border-top: 0;
  opacity: 0;
  transform: scaleY(0);
  transform-origin: top;
  pointer-events: none;
  transition: opacity 150ms ${animation.easeInOutCubic}, transform 150ms ${animation.easeInOutCubic};
  ${customScrollbar()};
`;

const Option = styled.li<{ isSelected?: boolean }>`
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  height: 48px;
  padding: 0 16px;
  color: ${brand.black};
  ${fonts.helvetica['55-roman']};
  font-size: 12px;
  text-transform: uppercase;
  border-bottom: 1px solid ${brand.grey[85]};
  background: ${brand.grey[95]};
  transition: color 150ms ${animation.easeInOutCubic};

  &:hover {
    color: ${brand.red.base};
    background-color: ${brand.grey[90]};
  }

  &:last-child {
    border-bottom: none;
  }

  ${({ isSelected }) =>
    isSelected
      ? css`
          color: ${brand.red.base};
        `
      : null};
`;

const Select = styled.div<{ isActive: boolean }>`
  /* position: relative; */
  display: flex;
  align-items: center;
  font-size: 12px;
  ${fonts.helvetica['63-medium-extended']};
  width: 100%;
  margin-top: 3px;

  @media ${from(Device.Tablet)} {
    padding: 0 30px 0px 16px;
    margin-top: 0px;
  }

  ${({ isActive }) =>
    isActive
      ? css`
          ${List} {
            border-top: 1px solid ${brand.grey[80]};
            opacity: 1;
            transform: scaleY(1);
            pointer-events: all;
          }
        `
      : null};
`;

const DropdownIcon = styled.div<{ isActive: boolean }>`
  transform: ${({ isActive }) => (isActive ? 'rotate(180deg);' : 'none')};
  transition: transform 0.15s ease;
  position: absolute;
  right: 6px;
  width: 16px;
  top: 50%;
  transform: translateY(-50%);
  color: #323232;

  @media ${from(Device.Tablet)} {
    right: 18px;
  }
`;

export const FilterSortStyles = {
  Title,
  Wrapper,
  Select,
  DropdownIcon,
  List,
  Option,
};
